import { render, staticRenderFns } from "./CodeBox.vue?vue&type=template&id=eff4aa56&scoped=true&"
import script from "./CodeBox.vue?vue&type=script&lang=js&"
export * from "./CodeBox.vue?vue&type=script&lang=js&"
import style0 from "./CodeBox.vue?vue&type=style&index=0&id=eff4aa56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff4aa56",
  null
  
)

export default component.exports